export const SIZE_TYPE = [
    {label: '通用', value: 0},
    {label: '中国码', value: 1},
    {label: '欧码', value: 2},
    {label: '英码', value: 3},
    {label: '德码', value: 4},
    {label: '美码', value: 5},
    {label: '均码', value: 6},
]

export const PROD_TYPE = [
    {label: '普通商品', value: 1},
    {label: '海外进口', value: 2},
    // {label: '直供（保税）', value: 3},
    // {label: '直邮', value: 4},
    // {label: '流量', value: 5},
    // {label: '话费', value: 6},
    // {label: '优惠券', value: 7},
    // {label: 'QQ充值', value: 8},
    // {label: '加油卡', value: 9},
    // {label: '商家卡券', value: 15},
    // {label: '平台卡券', value: 19},
]

export const SECOND_TYPE = [
    {label: '全新', value: 0},
    {label: '二手', value: 1},
]
export const PRESELL_TYPE = [
    {label: '非预售', value: 0},
    {label: '定时预售', value: 1, new: true},
    {label: '时段预售', value: 2, tip: '选择该预售方式需要有对应的时段预售权限，否则铺货会失败'}
]
export const PERIOD_PRESALE_OPTIONS = [3,4,5,6,7,8,9,10,11,12,13,14,15].map(day => {
    return {
        label: `${day}天`,
        value: day * 24 * 60 * 60
    }
})
export const DELAY_TIME = [
    {label: '当日发货', value: 0},
    {label: '24小时', value: 24*60*60},
    {label: '48小时', value: 48*60*60},
    // {label: '120小时', value: 120*60*60},
    // {label: '96小时', value: 96*60*60},
]

export function getDelayTimeOptions(goodsType) {
    if (goodsType == 1 || goodsType == 2) {
        return DELAY_TIME.slice(1,3);
    } else if (goodsType == 4) {
        return DELAY_TIME.slice(3, 4);
    } else if (goodsType == 3) {
        return DELAY_TIME.slice(4);
    } else {
        return DELAY_TIME.slice(0, 3);
    }
}

export const SHOP_ID = 83101;